import { useTranslation } from 'react-i18next';
import {
  StyledTextContainer,
  StyledTitleTypography,
  StyledTypography,
} from './styled';

const Header = () => {
  const { t } = useTranslation();

  return (
    <StyledTextContainer>
      <StyledTitleTypography>
        {t('account:youtubeChannel:whitelistContainer:title')}
      </StyledTitleTypography>
      <StyledTypography>
        {t('account:youtubeChannel:whitelistContainer:description')}
      </StyledTypography>
    </StyledTextContainer>
  );
};

export default Header;
